//need double verification
const portalLayer1 = [
    {
        icon: "11d",
        description: "Thunderstorm",
        style: 
            {
            backgroundImage: "var(--ThunderstormNoLightning_Day)",
            backgroundSize: "cover",
            } 
    },
    {
        icon: "11n",
        description: "Thunderstorm",
        style: 
            {
            backgroundImage: "var(--ThunderstormNoLightning_Night)",
            backgroundSize: "cover",
            },
    },
    {
        icon: "13d",
        description: "Snow",
        style:
            {
            backgroundImage: "var(--Snow_Day)",
            backgroundSize: "75% 75%",
            opacity: "0.5",
            transform: "rotate(10deg)",
            animation: "fall 8s linear infinite",
            filter: "blur(3px)",
            },
    },
    {
        icon: "13n",
        description: "Snow",
        style:
            {
            backgroundImage: "var(--Snow_Night)",
            opacity: "0.1",
            transform: "rotate(10deg)",
            animation: "fall 5s linear infinite",
            filter: "blur(5px)",
            },
    },
    {
        icon: "50d",
        description: "Mist",
        style: 
            {
            backgroundImage: "var(--OvercastClouds_Day)",
            backgroundSize: "cover",
            opacity: "0.5",
            transform: "rotate(-10deg)",
            animation: "wind 600s linear infinite",
            },
    },
    {
        icon: "50n",
        description: "Mist",
        style: 
            {
            backgroundImage: "var(--OvercastClouds_Night)",
            backgroundSize: "cover",
            opacity: "0.3",
            transform: "rotate(-10deg)",
            animation: "wind 600s linear infinite",
            },
    }
];

export default portalLayer1;


